import { useEffect } from 'react'
import type { RealtimeChannel } from '@supabase/supabase-js'
import { getSupabase } from './supabase/client'

export function usePrivateBroadcast(topic: string | null, onChange: () => void) {
  useEffect(() => {
    if (!topic) return
    const supabase = getSupabase()
    let active = true
    let channel: RealtimeChannel | null = null

    void supabase.auth.getSession().then(({ data }) => {
      if (!active || !data.session) return
      supabase.realtime.setAuth(data.session.access_token)

      channel = supabase
        .channel(topic, { config: { private: true } })
        .on('broadcast', { event: '*' }, onChange)
        .subscribe()
    })

    return () => {
      active = false
      if (channel) void supabase.removeChannel(channel)
    }
  }, [topic, onChange])
}
